export const zIndices = {};
